import React from "react";
import { Upload } from "antd";
import type { UploadProps } from "antd";
import axios from "axios";
import toast from "react-hot-toast";
import { MAX_FILE_SIZE_BYTES, MAX_FILE_SIZE_MB } from "@/constants";
import { useFileUpload } from "@/contexts/FileUploadContext";

interface FileUploadButtonProps {
  onFileChange: (file: any) => void;
  formatMessage: (id: string, values?: Record<string, any>) => string;
  setFileLoading?: any;
  maxCount?: number;
  children: React.ReactNode;
  showUploadList?: boolean;
}

//正式环境和预发布环境都取正式环境地址
const supportApiUrl =
  process.env.REACT_APP_ENV === "production" ||
  process.env.REACT_APP_ENV === "stage"
    ? process.env.REACT_APP_SUPPORT_API
    : "https://integrated-test.afirstsoft.cn";

/**
 * 上传文件按钮组件
 * @param param0
 * @returns
 */
const FileUploadButton: React.FC<FileUploadButtonProps> = ({
  onFileChange,
  formatMessage,
  maxCount = 1,
  children,
  showUploadList = true,
}) => {
  // 使用全局文件上传状态
  const { setFileUploading } = useFileUpload();
  const uploadProps: UploadProps = {
    name: "attachments",
    style: { cursor: "pointer" },
    maxCount,
    customRequest: async (options: any) => {
      const { onSuccess, onError, file } = options;
      try {
        setFileUploading(true);
        const formData = new FormData();
        formData.append("file", file);
        const { data } = await axios.post(
          `${supportApiUrl}/api/v1/upload`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        const { status, body } = data;
        if (status === 200) {
          onSuccess({ ...data, name: body?.name || file?.name, uid: file.uid });
        } else {
          toast.error(`${file.name}${formatMessage("fileUploadFailed")}`);
          onError();
        }
      } catch (e) {
        toast.error(`${file.name}${formatMessage("fileUploadFailed")}`);
        onError();
      } finally {
        setFileUploading(false);
      }
    },
    onChange({ file }) {
      onFileChange(file);
    },
    beforeUpload: (file) => {
      // 检查文件大小
      if (file.size > MAX_FILE_SIZE_BYTES) {
        toast.error(
          `${file.name} ${formatMessage("fileSizeExceeded", {
            maxSize: MAX_FILE_SIZE_MB,
          })}`
        );
        return Upload.LIST_IGNORE;
      }
      return true;
    },
    showUploadList: showUploadList,
  };

  return <Upload {...uploadProps}>{children}</Upload>;
};

export default FileUploadButton;
